var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VCol',{staticClass:"align-center",attrs:{"cols":"12"}},[_c('div',{staticClass:"mt-2"},_vm._l((12),function(_){return _c('VSkeletonLoader',{staticClass:"mb-2 py-2",attrs:{"type":"text"}})}),1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }